import downloadTop from '@/assets/download/download_top.webp';
import BlurryLoadingImage from '@/components/progressive-img';
import RecommendGames from '@/modules/RecommendGames';

import styles from './styles.module.less';

const Download = () => {
  return (
    <div className={styles.box}>
      <div className={styles.container}>
        <div className={styles.main}>
          <BlurryLoadingImage loading="lazy" src={downloadTop} className={styles.imgTop} alt="" />
          <div className={styles.title}>Bloqueado</div>
          {/* <div className={styles.content}>
            <div>Recarregue ou jogue mais jogos</div>
            <div> para desbloquear aleatoriamente</div>
          </div> */}
        </div>
        <RecommendGames />
      </div>
    </div>
  );
};
export default Download;
